export const de: object = {
  configurator: {
    additionalRequiredSolution: '1 zusätzliche erforderliche Lösung',
    additionalRequiredSolution_plural: '{{count}} zusätzlich erforderliche Lösungen',
    startDate: 'Tag beginnen',
    checkOut: 'Check out',
    licenseMaterial: 'Lizenzen Material',
    licenseDetails: 'Lizenz Details',
    backToSolutionPage: 'Zurück',
    backToSolutionPageMobile: 'Zurück',
    configureYourSolution: 'Ihre Konfiguration',
    yourConfiguration: 'Ihre Konfiguration',
    pricingSummary: 'Preisübersicht',
    recurringTotal: 'Periodischer Gesamtpreis',
    totalCost: 'Gesamtkosten',
    orderSummary: 'Bestellzusammenfassung',
    per: 'Pro',
    month: 'Monat',
    subtotal: 'Zwischensumme',
    yearByYearPricingBreakdown: 'Preisaufschlüsselung nach Jahr',
    additionalServicesFee: 'Additional Services Fee',
    orderTotal: 'Order Total',
    taxCalculationCheckout: 'Tax calculated at Checkout',
    taxDiscountsCalculationCheckout: 'Tax and discounts calculated at Checkout',
    psTaxExclusion: 'Ohne Steuern',
    date: {
      endDate: 'End Datum: ',
      startDate: 'Start Date: ',
      yearsAndMonths: '{{years}} Jahre, {{months}} Monate',
      invalid: 'Geben Sie ein Datum im Format DD-MMM-YYYY ein',
      required: 'Start Datum ist ein Pflichtfeld',
      minDate: 'Datum muss später sein als {{minDate}}',
      maxDate: 'Datum muss früher sein als {{maxDate}}',
      renewal: 'Verlängert automatisch',
      renewalTooltip:
        'Vor der nächsten Verlängerung erhalten Sie eine E-Mail mit den Transaktionsdetails. Sie können Ihr Abonnement vor dem Verlängerungsdatum kündigen.',
      recurringMonths: 'Alle {{months}} Monate',
      recurringYears: '{{months}} Monate ({{years}} Jahre)',
      annual: 'Jährlich',
      year: '{{months}} Monate (1 Jahr)',
    },
    deploymentSystems: {
      deployment: 'Einsatz',
      system_plural: 'Systeme',
      system: 'System',
      description:
        'Zusätzliche Lizenzen werden automatisch auf allen relevanten Systemen in Ihrem Vertrag bereitgestellt:',
      columnSystemNumber: 'Systemnummer',
      columnName: 'Name',
      columnRole: 'Rolle',
    },
    units: {
      usr: 'Benutzer',
      blocksOf: 'In Blöcken von {{amount}} {{unit}}',
    },
    endDateToolTooltip: 'Lizenzen werden Ihrem bestehenden Vertrag hinzugefügt und verlängert',
    excludingTax: 'Ohne Steuern',
    pricingBillingTermsApply: 'Bestehende Vertrags- Preise, Fakturierung und Bedingungen gelten',
    quantity: {
      required: 'Anzahl ist ein Pflichtfeld',
      noNegatives: 'Anzahl muss eine positive Zahl sein',
      onlyWholeNumbers: 'Anzahl muss eine ganze Zahl sein',
      minimum: 'Anzahl muss mindestens {{value}} sein',
      maximum: 'Anzahl darf maximal {{value}} sein',
      outOfBounds: 'Bitte geben sie eine Anzahl zwischen ({{minValue}}-{{maxValue}}) ein',
      step: 'Menge muss ein Vielfaches von {{value}} sein',
      minimumOf: 'Mindestens {{value}} {{unit}}',
      incrementsOf: 'In Schritten von {{amount}} {{unit}}',
      maximumOf: 'Maximal {{value}} {{unit}}',
      minimumWithIncrements: 'Mindestens {{value}} {{unit}} in Schritten von {{amount}}',
    },
    addToCart: {
      buttonUpdateCart: 'Update Cart',
      buttonContinueToCart: 'Continue',
    },
    addLicense: 'Lizenz hinzufügen',
    addLicenses: 'Lizenzen hinzufügen',
    editAdditionalLicenses: 'Bearbeite zusätzliche Lizenzen',
    editOrderDetails: 'Auftragsdetails bearbeiten',
    closeModalLabel: 'Schließe das Modal und speichere keine Änderungen',
    partOfBundle: '{{productName}} ({{product}}) wurde ursprünglich als Teil eines Lösungspakets gekauft.',
    orderUpsellBundle:
      ' Um Ihrem Abonnement Lizenzen hinzuzufügen, müssen Sie zusätzliche Lizenzen für eine der folgenden Lösungen erwerben:',
    requestLicenses: 'Lizenzen anfragen',
    requestAdditionalLicenses: 'Zusätzliche Lizenzen anfordern',
    yourSolutions: 'Ihre Lösungen',
    completeFormCta:
      'Um zusätzliche Lizenzen dieses Produkts zu erwerben, füllen Sie bitte das Formular aus, um unseren SAP Digital Kundenservice zu kontaktieren.',
    selfServiceOrdering:
      'Die Bestellung via Self Service wird zeitnah ermöglicht, um die Lizenzen für Sie schneller und einfacher zu Ihrem Abonnement hinzuzufügen.',
    errorMessage: {
      btnText: 'Warenkorb anzeigen',
    },
    error: {
      somethingWrong: 'Etwas ist schief gelaufen',
      contactUsLink: 'Kontaktieren Sie uns',
      code: '(Code: {{errorCode}})',
      tryAgain: {
        message1:
          'Es scheint ein Problem mit unserem System aufgetreten zu sein. Bitte versuchen Sie es später noch einmal. Wenn das Problem weiterhin besteht, zögern Sie bitte nicht, ',
        buttonText: 'Versuchen Sie es noch einmal',
      },
      contactUs: {
        message:
          'Es scheint ein Problem mit unserem System aufgetreten zu sein. Bitte kontaktieren Sie uns, um fortzufahren.',
        buttonText: 'Kontaktieren Sie uns',
      },
      newContract: {
        headline: 'Neuen Vertrag beginnen?',
        message1: 'Ihr Unternehmen hat einen bestehenden Vertrag für',
        message2:
          'Wenn Sie einen neuen Vertrag abschließen möchten, wenden Sie sich bitte an Ihren Vertriebsmitarbeiter oder',
      },
      addToContract: {
        headline: 'Zu Ihrem bestehenden Vertrag hinzufügen?',
        message1: 'Ihr Unternehmen hat einen bestehenden Vertrag für ',
        message2: '. Klicken Sie unten, um weitere Credits mit denselben Vertragsbedingungen zu kaufen',
        message3:
          'Wenn Sie einen neuen Vertrag abschließen möchten, wenden Sie sich bitte an Ihren Vertriebsmitarbeiter oder',
        buttonText: 'Mehr kaufen',
      },
      addToCart: {
        multiCurrencyCart:
          'Dieser Artikel kann nicht zusammen mit den Artikeln in Ihrem Warenkorb gekauft werden, da diese unterschiedliche Währungen verwenden. Bitte überprüfen Sie zuerst Ihren Warenkorb.',
      },
      addCompanyDetails: {
        headline: 'Unternehmensdetails hinzufügen',
        message1: 'Für den Kauf von',
        message2:
          'benötigen wir weitere Informationen über Ihr Unternehmen. ' +
          'Um diese Informationen zu Ihrem Konto hinzuzufügen, bitte ',
      },
      checkoutUnavailable: {
        headline: 'Entschuldigung, die Kasse ist gesperrt',
        message1:
          'Der bestehende Vertrag kann nicht über den SAP Store online abgeschlossen werden oder dieser Kauf erfordert eine spezielle Benutzerberechtigung.',
        message2:
          'Wenden Sie sich bitte an Ihren Vertriebsmitarbeiter oder an SAP Store, indem Sie eine Support-Anfrage erstellen.',
        buttonText: 'Zurück zur Lösungsseite',
        buttonText2: 'Supportanfrage erstellen',
      },
      noError: '',
    },
    euAccessTooltip:
      'EU Zugang ist ein zusätzliches Service-Element, mit dem SAP den Fernzugriff auf Daten und die Datenspeicherung nur auf die Europäische Union (EU), den Europäischen Wirtschaftsraum (EWR) und die Schweiz beschränkt.',
    on: 'An',
    off: 'Aus',
    bookmark: 'Lesezeichen',
    globalAccounts: {
      addToGlobalAccount: 'Globales Konto',
      addToGlobalAccountDescription: 'Fügen Sie diese Lösung zu Ihrem bestehenden SAP BTP Global Account hinzu.',
      accountDetailsRows: 'Globale Konten-ID, Kommerzielles Modell, Datum erstellt',
      gaNotSelectedInfoNote:
        'Wenn Sie diese Konfiguration deaktivieren, wird mit dieser Bestellung ein neues globales BTP-Konto erstellt.',
      gaInfoNoteCtaQuestion: 'Sie wissen nicht, was BTP Global Account ist',
      gaInfoNoteContactHere:
        'Kontaktieren Sie Ihren Vertriebsmitarbeiter oder erfahren Sie mehr über BTP Global Account',
      gaInfoNoteContactHereLinkText: 'hier',
      errors: {
        missingPurchaseRole1:
          'Da dieser Kauf die Konfiguration eines bestehenden Mieters/einer bestehenden Landschaft ändern wird, ist eine spezielle Autorisierung (Kauflizenzen) erforderlich, um diese Bestellung aufzugeben. Dies kann Ihnen von einem der gewährt werden',
        missingPurchaseRole2: 'die Administratoren Ihres Unternehmens',
        missingPurchaseRole3: 'Bitte wenden Sie sich an einen von ihnen, um diese Genehmigung zu erhalten.',
        required:
          'Bitte wählen Sie ein Konto aus, wenn diese Lösung zu einem bestehenden globalen BTP-Konto hinzugefügt wird.',
      },
    },
    ctaValidateInfoMessage:
      'Bitte warten Sie, während wir prüfen, ob Sie bestehende Verträge haben, die diesen Kauf beeinflussen könnten.',
    addOns: {
      errors: {
        required: 'Please make a selection',
      },
    },
    leavePageModal: {
      headline: 'Nicht gespeicherte Konfiguration',
      text: 'Ihre aktuelle Konfiguration wurde nicht zum Warenkorb hinzugefügt und geht möglicherweise verloren, wenn Sie diese Seite verlassen.',
      cancelButton: 'Abbrechen',
      continueButton: 'Fortfahren',
    },
  },
};
